export default {
    type: null,
    aliases: {
        singular: null,
        plural: null,
    },
    publishable: false,
    adminSection: null,
    componentType: null,
    components: {
        adminRecord: {
            name: 'AdministerRecord',
            loader: () => import('./ui/AdministerRecord')
        },
        adminCollection: {
            name: 'AdministerCollection',
            loader: () => import('./ui/AdministerCollection')
        },
        adminCollectionItem: {
            name: 'AdministerCollectionItem',
            loader: () => import('./ui/AdministerCollectionItem')
        },
        adminRelations: {
            name: 'AdministerRelations',
            loader: () => import('./ui/AdministerRelations')
        },
        adminModules: {
            name: 'AdministerModules',
            loader: () => import('./ui/AdministerModules')
        },
    }
};
